import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { DotsSixVerticalIcon } from '@phosphor-icons/react'

import ReturnInstructionItem from '../ReturnInstructionItem/ReturnInstructionItem'
import * as Styles from './styles'

const SortableReturnInstruction = props => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({
    id: props.data.id,
    disabled: !props.isEditable,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <Styles.SortableItemContainer ref={setNodeRef} style={style} index={props.index} isSortable={props.isEditable}>
      <DotsSixVerticalIcon size={24} id="draggable-icon" data-testid="draggable-icon" {...attributes} {...listeners} />
      <ReturnInstructionItem {...props} />
    </Styles.SortableItemContainer>
  )
}

export default SortableReturnInstruction
